import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import type { Feature } from '../feature'

/**
 * Triggers disposal of Entity Collection instances when a widget render request is made.
 */
export const triggerEcDisposeOnWidgetRenderRequest = store.effects.create(
  (feature: Feature, dynamicEcsFeature: dynamicEcs.Feature) =>
    feature.actions.render.request.observe().pipe(
      rxjs.switchMap(action =>
        rxjs.of(action).pipe(
          // Resolve entity collection for the widget ref, and ensure it exist
          rxjs.withLatestFrom(
            dynamicEcsFeature.selectors.getDynamicEc(action.data.ref)
              .asObservable,
          ),
          rxjs.map(
            ([
              {
                data: { ref },
              },
              collection,
            ]) =>
              // Check if a collection exists before disposal
              // this prevents unnecessary disposal during initial render
              // and handles re-renders of existing table widgets with bootstrapped collections
              collection
                ? dynamicEcsFeature.actions.dispose
                    .from('triggerEcDisposeOnWidgetRenderRequest (effect)')
                    .create({ ref })
                : // otherwise, skip the effect
                  store.effects.SKIP,
          ),
        ),
      ),
    ),
)
